import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AreaChartsModule } from '@nttp/area-chart/area-chart.module';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { AreaChartComponent } from '@pg-app/partner/dashboard/components/area-chart/area-chart.component';
import { DialogOverviewExampleDialog } from '@pg-app/partner/dashboard/components/dialog/dialog-overview.component';
import { DonutChartComponent } from '@pg-app/partner/dashboard/components/donut-chart/donut-chart.component';
import { FunnelDialogOverviewExampleDialog } from '@pg-app/partner/dashboard/components/funnel-dialog/funnel-dialog-overview.component';
import { FunnelModalComponent } from '@pg-app/partner/dashboard/components/funnel-modal/funnel-modal.component';
import { DashboardModalComponent } from '@pg-app/partner/dashboard/components/modal/dashboard-modal.component';
import { TableRatioConvertedComponent } from '@pg-app/partner/dashboard/components/table/converted/ratio/ratio-converted.component';

import { TableReferralConvertedComponent } from '@pg-app/partner/dashboard/components/table/converted/referral/referral-converted.component';

import { TableFunnelOpportunityComponent } from '@pg-app/partner/dashboard/components/table/funnel-opportunity/funnel-opportunity.component';
import { TableInSalesProcessComponent } from '@pg-app/partner/dashboard/components/table/in-sales-process/in-sales-process.component';
// Table in modal
import { TableLeadsComponent } from '@pg-app/partner/dashboard/components/table/leads/leads.component';
import { TableMonthlyCommisionComponent } from '@pg-app/partner/dashboard/components/table/monthly-commision/monthly-commision.component';

import { TableMostRecentActivityComponent } from '@pg-app/partner/dashboard/components/table/most-recent-activity/most-recent-activity.component';
import { TableTradedAccountComponent } from '@pg-app/partner/dashboard/components/table/traded-account/traded-account.component';
import { SumPipe } from '@pg-app/partner/dashboard/components/_pipes/sum.pipe';
import { DashboardComponent } from '@pg-app/partner/dashboard/containers/dashboard.component';
import { DashboardRoutingModule } from '@pg-app/partner/dashboard/dashboard-routing.module';
import { ChartDataService } from '@pg-app/partner/dashboard/services/chart.service';
import { TableDialogService } from '@pg-app/partner/dashboard/services/table-dialog.service';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from '@pg-app/core/services/localization.service';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { CheckAccountModule } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.module';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { SendReferralComponent } from './components/send-referral/send-referral.component';

@NgModule({
  declarations: [
    DashboardComponent,
    SumPipe,
    DonutChartComponent,
    AreaChartComponent,
    DashboardModalComponent,
    TableLeadsComponent,
    TableMostRecentActivityComponent,
    TableTradedAccountComponent,
    TableInSalesProcessComponent,
    TableRatioConvertedComponent,
    TableReferralConvertedComponent,
    TableMonthlyCommisionComponent,
    DialogOverviewExampleDialog,
    FunnelDialogOverviewExampleDialog,
    FunnelModalComponent,
    TableFunnelOpportunityComponent,
    SendReferralComponent,
  ],
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    DashboardRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    NgTableModule,
    AreaChartsModule,
    TranslateModule,
    CommonDialogModule,
    CheckAccountModule,
    PipeModule
  ],
  providers: [ChartDataService, TableDialogService, LocalizationService],
  entryComponents: [
    DialogOverviewExampleDialog,
    FunnelDialogOverviewExampleDialog,
  ]
})
export class DashboardModule { }
